module.exports = "<svg id=\"ad2f189a-4062-45c9-bef2-73745515a36f\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 51 51\"><circle class=\"circle\" cx=\"25.5\" cy=\"25.5\" r=\"25\" fill=\"none\"></circle><path class=\"triangle\" fill=\"#D3D3D3\" d=\"M39.16,24.59,19,14.45a1.58,1.58,0,0,0-2.28,1.41V36.14A1.58,1.58,0,0,0,19,37.55L39.16,27.41A1.58,1.58,0,0,0,39.16,24.59Z\" transform=\"translate(-0.5 -0.5)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/play.svg
// module id = cHMr
// module chunks = 11